
import { WeeklyReport } from "../components/Manager/WeeklyReport";

const WeeklyReportPage = () => {
  return <WeeklyReport />;
};

export default WeeklyReportPage;
